export interface IHttpClient {
    showProgress: boolean,
    method: string,
    url: string,
    storeKey?: string | null,
    businessDate?: string | null,
    payload?: object | null,
    token?: string | null,
    refreshToken?: string | null,
    noCache?: boolean,
    headers?: Record<string, string>
}

/**
 * A utility class for making HTTP requests to a remote server.
 */
export class AdoraHttpClient {

    /**
     * Sends an HTTP request described by the given options.
     * @param {IHttpClient} request - The method, URL, payload, tokens and extra headers for the request.
     * @returns {Promise<Response>} - A Promise that resolves to the Response object representing the server's response.
     */
    static async httpRequest(request: IHttpClient): Promise<Response> {
        const init: { method: string, headers: Headers, body?: string } = {
            method: request.method,
            headers: AdoraHttpClient._buildHeaders(request),
        };

        if (request.payload)
            init.body = JSON.stringify(request.payload);

        return fetch(new Request(request.url), init);
    }

    private static _buildHeaders(request: IHttpClient): Headers {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json; charset=utf-8');

        if (request.storeKey)
            headers.append('X-Store-Key', request.storeKey);

        if (request.businessDate)
            headers.append('X-Business-Date', request.businessDate);

        if (request.noCache ?? true) {
            headers.append('pragma', 'no-cache');
            headers.append('cache-control', 'no-cache');
        }

        if (request.token)
            headers.append('Authorization', `Bearer ${request.token}`);

        if (request.refreshToken)
            headers.append('rtk', request.refreshToken);

        for (const [name, value] of Object.entries(request.headers ?? {}))
            headers.append(name, value);

        return headers;
    }
}
